import { ArrowKeys } from '../../../core/types/generic/keys';
import {
  Area,
  CellPosition,
  IRange,
  SelectionCell,
  Sheet,
  SheetSelection,
  SheetView,
} from '../../types';
import { expandAreaToPartialChangedPosition } from '../selection/selection';
import { convertPositionToArea } from '../area/area';
import { fitCellInViewport } from './viewport';
import { DataDirection } from '../../../core/types/ui/position';
import { unionAreaWithMerges } from './merges';
import {
  ArrowKeysPositionReturnType,
  setBackwardPositionIndex,
  setForwardPositionIndex,
} from './jumpWithKeys';
import { getEntitiesData } from '../sheet/uiData';

export function invertKey(key: string, isRtl: boolean) {
  if (isRtl) {
    switch (key) {
      case ArrowKeys.Left:
        return ArrowKeys.Right;
      case ArrowKeys.Right:
        return ArrowKeys.Left;
      default:
        return key;
    }
  } else {
    return key;
  }
}

export const createNewPositionFromArrowKey = (
  sheet: Sheet,
  sheetView: SheetView,
  // activeCellArea: Area, // May be greater than active cell because it may contains merge
  key: string,
  { start, end }: Area,
  shiftKey?: boolean
) => {
  const { activeCellArea } = sheetView;
  const {
    cols,
    rows,
    hiddenCols,
    hiddenRows,
    maxColIndex,
    maxRowIndex,
    freezedRows,
    freezedCols,
  } = sheet;

  // New position is actual changed position based on arrow keys
  // In case of merge if colIndex is changed we'll keep rowIndex same as old one so on next "right" arrow key we'll use
  // That row index as a base to jump
  const newPosition: Partial<CellPosition> = {};

  // Corresponding Position is only used with merge to fit top left cell in viewport
  const correspondingPosition: Partial<CellPosition> = {};

  let range: IRange | undefined = undefined;

  const findPositionIndex = (
    dir: DataDirection,
    isCol: boolean
  ): ArrowKeysPositionReturnType => {
    // const indices = isCol ? cols : rows;
    // const hiddenRanges = isCol ? hiddenCols : hiddenRows;
    // const maxIndexCount = isCol ? maxColIndex : maxRowIndex;
    // const frozenIndices = isCol ? freezedCols : freezedRows;
    // const filterResults = isCol ? undefined : sheetView.filterResults;

    const entityData = getEntitiesData(sheet, sheetView, isCol);

    const alias = isCol ? 'ci' : 'ri';

    if (dir === DataDirection.Backward) {
      return setBackwardPositionIndex(
        shiftKey ? { start, end } : activeCellArea,
        activeCellArea,
        entityData.entitySizes,
        entityData.hiddenRanges,
        alias,
        entityData.maxIndex,
        sheet,
        !!shiftKey,
        entityData.freeze,
        entityData.filterResults
      );
    } else {
      return setForwardPositionIndex(
        shiftKey ? { start, end } : activeCellArea,
        activeCellArea,
        entityData.entitySizes,
        entityData.hiddenRanges,
        alias,
        entityData.maxIndex,
        sheet,
        !!shiftKey,
        entityData.freeze,
        entityData.filterResults
      );
    }
  };

  switch (key) {
    case ArrowKeys.Up:
    case ArrowKeys.Down: {
      const dir =
        key === ArrowKeys.Up ? DataDirection.Backward : DataDirection.Forward;
      const results = findPositionIndex(dir, false);
      newPosition.ri = results.idx;
      range = results.range;
      if (results.correspondingIndex !== undefined) {
        correspondingPosition.ci = results.correspondingIndex;
      }
      break;
    }
    case ArrowKeys.Right:
    case ArrowKeys.Left: {
      const dir =
        key === ArrowKeys.Right
          ? DataDirection.Forward
          : DataDirection.Backward;
      const results = findPositionIndex(dir, true);
      newPosition.ci = results.idx;
      range = results.range;
      if (results.correspondingIndex !== undefined) {
        correspondingPosition.ri = results.correspondingIndex;
      }
      break;
    }
  }
  return {
    position: newPosition,
    correspondingPosition,
    range: range,
  };
};

export const getAreaAndViewportAccordingToPos = (
  sheet: Sheet,
  sheetView: SheetView,
  newPosition: Partial<CellPosition>,
  newRange: IRange | undefined,
  positionToFitInViewport: CellPosition, // Mixture of correspondingPosition and newPosition
  area: Area,
  selection: SheetSelection,
  windowWidth: number,
  windowHeight: number,
  shiftKey = false
) => {
  if (shiftKey) {
    selection.area = expandAreaToPartialChangedPosition(
      newPosition,
      newRange,
      sheetView.activeCell,
      area
    );
  } else {
    selection.cell = SelectionCell.Cell;
    selection.area = convertPositionToArea(positionToFitInViewport);
  }

  selection.area = unionAreaWithMerges(sheet.merges, selection.area);

  const cellFitted = fitCellInViewport(
    sheet,
    positionToFitInViewport,
    sheetView,
    windowWidth,
    windowHeight
  );

  return cellFitted;
};

export const jumpCellWithCtrlKey = (
  sheet: Sheet,
  sheetView: SheetView,
  currentPosition: CellPosition,
  key: string
) => {
  let newPosition: Partial<CellPosition> = { ...currentPosition };

  if (key === ArrowKeys.Down || key === ArrowKeys.Right) {
    // newPosition = findVisibleDataCell(
    //   currentPosition,
    //   sheet,
    //   sheetView,
    //   key === ArrowKeys.Down ? 'ri' : 'ci',
    //   DataDirection.Forward
    // );
  } else if (key === ArrowKeys.Up || key === ArrowKeys.Left) {
    // newPosition = findVisibleDataCell(
    //   currentPosition,
    //   sheet,
    //   sheetView,
    //   key === ArrowKeys.Up ? 'ri' : 'ci',
    //   DataDirection.Backward
    // );
  }

  return newPosition;
};
